let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7deKw")).then(() => parcelRequire('g9B72'));